// Global runtime polyfills, imported for side effect from EVERY html entry
// point — currently `main.tsx` and `popout.tsx`. Kept here, not in a component
// file, so the augmentation loads regardless of which components mount, and so
// no component pollutes the global prototype on its own.
//
// Callers use `Number.prototype.clamp` as a METHOD, so a missing import isn't
// a subtle degradation — it's a TypeError that unmounts the React tree. That
// is exactly what happened when only main.tsx imported this: every popout
// rendering a `.clamp()` caller (WavetablePanel's MorphKnob, the modular
// visualisers, VibeFX, export progress) came up as a blank window.
// If you add a new html entry, import this first.

declare global {
  interface Number {
    /** Clamp this number to the inclusive [min, max] range. */
    clamp(min: number, max: number): number;
  }
}

if (!Number.prototype.clamp) {
  Number.prototype.clamp = function (this: number, min: number, max: number): number {
    return Math.min(Math.max(this, min), max);
  };
}

export {};
